import React from 'react'
import PropTypes from 'prop-types'


const Template = ({template, onEdit, onDelete}) => {
  return (
    <div className='template'>
      <div className='template-header'>
        <div className='template-title'><i className= 'fa fa-list'></i>{template.title}</div>
        <div className='template-buttons'>
          <span className='fa fa-pencil' onClick={() => onEdit(template)}></span>
          <span className='fa fa-trash' onClick={() => onDelete(template)}></span>
        </div>
      </div>
      <div className='template-text'>{template.text}</div>
    </div>
  )
}

Template.propTypes = {
  template: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default Template
